import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { validateCreditCardNumber } from '../utils/credit-card.util';

export function creditCardNumberValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => validateCreditCardNumber(control.value);
}
